var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-8" }, [
      _vm._m(0),
      _vm.getData.imagenLink != null
        ? _c("div", { staticClass: "mt-3 container-data" }, [
            _c("iframe", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                height: "1000",
                width: "100%",
                src: _vm.getData.imagenLink,
                frameborder: "0"
              }
            })
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "col-4" }, [
      _vm.getData
        ? _c("div", { staticClass: "margen-inferior" }, [
            _c(
              "div",
              [
                _c("h4", {}, [_vm._v("Resumen Actividad")]),
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Todos / Importantes")
                ]),
                _c("vs-switch", {
                  model: {
                    value: _vm.switchImportantes,
                    callback: function($$v) {
                      _vm.switchImportantes = $$v
                    },
                    expression: "switchImportantes"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mt-3 container-data" },
              [
                _vm.binnacleData.length
                  ? _c(
                      "app-timeline",
                      _vm._l(_vm.binnacleData, function(binnacle) {
                        return _c(
                          "app-timeline-item",
                          {
                            key: binnacle.bitacoraId,
                            attrs: { icon: "InfoIcon", variant: "primary" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-sm-row flex-column flex-wrap\n               justify-content-between mb-1 mb-sm-0"
                              },
                              [
                                _c("h6", [
                                  _vm._v(_vm._s(binnacle.usuarioNombre))
                                ]),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateCompleteFormat")(
                                          binnacle.fecha
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-sm-row flex-column flex-wrap\n               justify-content-between mb-1 mb-sm-0"
                              },
                              [
                                _c("p", [_vm._v(_vm._s(binnacle.mensaje))]),
                                _c("div", { staticClass: "mb-1 mb-sm-0" }, [
                                  _c(
                                    "div",
                                    [
                                      binnacle.tipoVista == -1 ||
                                      binnacle.tipoVista == 0
                                        ? _c("b-avatar", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass: "mr-50",
                                            attrs: {
                                              title:
                                                "Registro Visible solo para Admin",
                                              text: "O",
                                              size: "24",
                                              icon: "eye-slash-fill",
                                              variant: "secondary"
                                            }
                                          })
                                        : _vm._e(),
                                      _c("b-avatar", {
                                        directives: [
                                          {
                                            name: "has-permission",
                                            rawName: "v-has-permission",
                                            value: "FEB99",
                                            expression: "'FEB99'"
                                          },
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass: "mr-50 add-code",
                                        attrs: {
                                          title: "Copiar Seguimiento",
                                          text: "S",
                                          size: "24",
                                          icon: "bug",
                                          variant: "success"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.copyToClipboard(
                                              binnacle.seguimientoId
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                !_vm.binnacleData.length
                  ? _c("div", [
                      _c("span", [_vm._v(" Sin registros para mostrar ")])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h4", {}, [_vm._v("Representación gráfica")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }